import { createAction } from '@reduxjs/toolkit';

import { type PermissionsState } from './types';

export const setPermissionsAction = createAction<Partial<PermissionsState>>('SET_PERMISSIONS');

export const resetPermissionsAction = createAction('RESET_PERMISSIONS');
